
        <h1>Beachwatch data feeds</h1>
        <p class="nsw-intro">Use our daily water quality forecast in your web and mobile applications.</p>


    <nav class="nsw-in-page-nav bw-in-page-nav" aria-labelledby="in-page-nav">
        <div id="in-page-nav" class="nsw-in-page-nav__title">On this page</div>
        <ul>
            <li>
                <a routerLink="./" fragment="aboutDataFeeds">About data feeds</a>
            </li>
            <li>
                <a routerLink="./" fragment="conditionsOfUse">Conditions of use</a>
            </li>            
        </ul>
    </nav> 

    <section  id="aboutDataFeeds">
        <div class="nsw-block"   style="margin-bottom:3rem;">
            <h2 id="aboutDataFeedsTitle">About data feeds</h2>
            <p>  
                Beachwatch water quality forecast data feed is updated twice daily at 6 am and 1:30 pm and may be updated during the day if conditions change.
                <br/><br/>
                View the <app-external-link text="User guide for API." link="assets/documents/public-api-documentation.pdf" [download]="true"></app-external-link>
                <br/>
                View the <app-external-link text="User guide for RSS." link="assets/documents/public-rss-documentation.pdf" [download]="true"></app-external-link>
            </p>                   
        </div>               
    </section>

    <section  id="conditionsOfUse">
        <div class="nsw-block" >
            <h2 id="conditionsOfUseTitle">Conditions of use</h2>
            <p>  
                The beach pollution forecast API and RSS feed is openly accessible and does not require registration or a subscription key.
                <br/><br/>
                Users must note though that any data accessed is owned by the Department of Planning and Environment and is protected by Crown Copyright, unless credited otherwise. 
                These are licensed under the
                <app-external-link text="Creative Commons Attribution 4.0 International (CC BY 4.0)" 
                    [link]="CREATIVE_COMMONS_ATTRIBUTION_URL"></app-external-link>                                
                subject to the exemptions contained in the licence.
                <br/><br/>
                Beachwatch water quality forecast are predictions of water quality only and are not 100% accurate.
                <br/>
                Beachwatch cannot guarantee the accuracy of any of the results or outputs from this model. Any reliance you place on such information is strictly at your own risk.
                <br/><br/>
                View <app-external-link text="Copyright and disclaimer webpage." 
                    [link]="COPYRIGHT_DISCLAIMER_PAGE_URL"></app-external-link>
            </p>                   
        </div>               
    </section>

    <div class="nsw-callout bw-content-margin">
        <div class="nsw-callout__content">
            <p class="nsw-h4">Download Beachwatch data</p>
            <p>The water quality data collected under the Beachwatch program can be viewed or downloaded.</p>
            <button type="button" style="margin-top: 0.75rem;"
                class="nsw-button nsw-button--dark"
                routerLink="/waterMonitoring/waterQualityData">Explore our data
            </button>
        </div>
      </div>

